import { render, staticRenderFns } from "./blood-oxygen-unit.vue?vue&type=template&id=708b81f1&scoped=true"
import script from "./blood-oxygen-unit.vue?vue&type=script&lang=js"
export * from "./blood-oxygen-unit.vue?vue&type=script&lang=js"
import style0 from "./blood-oxygen-unit.vue?vue&type=style&index=0&id=708b81f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708b81f1",
  null
  
)

export default component.exports